module.exports = __webpack_public_path__ + "static/img/4_2.264fdbe3.jpg";